import { render, staticRenderFns } from "./SeancesList.vue?vue&type=template&id=56be97b1&"
import script from "./SeancesList.vue?vue&type=script&lang=js&"
export * from "./SeancesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports